export const useScrollToView = () => {
  const handleScrollTo = (element: HTMLElement, offset = 0) => {
    const elemRect = element.getBoundingClientRect();
    const top = elemRect.top + window.scrollY;
    window.scrollTo({ top: top - offset, behavior: 'smooth' });
  };

  return { handleScrollTo };
};
